import { DateTime } from "luxon";
import { IoCloseCircle } from "react-icons/io5";

export default function FormDate(props) {
   var label = props.label || props.field;
   var field = props.field || props.label;
   const obj = props.formObject?.object || {};
   const camel = field ? field.charAt(0).toLowerCase() + field.slice(1) : "";
   var value =
      props.value ||
      obj[field] ||
      (camel && obj[camel]) ||
      "";
   if (value) {
      value = DateTime.fromISO(value).toFormat("yyyy-MM-dd");
   }

   const onChange = (e) => {
      console.log("Date field '" + props.field + "' changed to: " + e.target.value);
      if (props.formObject.hasOwnProperty("onChange"))
         props.formObject.onChange(e.target.value, props.field, "FormDate", e);
   };
   const clearBtn = (e) => {
      if (props.formObject.hasOwnProperty("onChange")) props.formObject.onChange("", props.field, "FormDate", e);
   };
   console.log(label + " Date: " + value);
   return (
      <div className={`field FormDate form-group${props.className ? ` ${props.className}` : ""}`} hidden={props.hidden || undefined}>
      <label htmlFor={field} className="form-label">
        {label}
      </label>
      <input
        id={field}
        type="date"
        value={value ? value : ""}
        onChange={onChange}
        className="form-input"
      />
         {props.nullable ? <IoCloseCircle className="clearBtn" onClick={clearBtn} title="Clear" /> : ""}
      </div>
   );
}
